import React from 'react';

// This is now just a stub component that always returns children
// since we no longer need theme switching functionality
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}

// This hook now returns a simplified interface with no theme switching
export function useTheme() {
  return {
    theme: 'light',
    toggleTheme: () => {},
  };
}